import { 
    store, 
    getContext, 
    getElement,
    withScope,
    useState, 
    useEffect,
    getServerState
} from '@wordpress/interactivity';


const { callbacks } = store( 'cwc/theme', {
    callbacks: {
        setHasCache: ( /** @type {Event} */ event ) => {
            /** @type {any} */
            const context = getContext()

            context.masonry.layout()
        },
        updateContainerWidth: () => {
            /** @type {any} */
            const context = getContext()
            const { ref } = getElement()

            const { containerWidth } = callbacks.getGridLayout( ref )

            context.containerWidth = containerWidth
        },
        updateLayoutParams: () => {
            // @ts-ignore
            if ( !window.Masonry )
                return;

            /** @type {any} */
            const context = getContext()
            const { ref } = getElement()

            const { 
                count, 
                itemWidth, 
                gap, 
                containerWidth, 
                containerHeight 
            } = callbacks.getGridLayout( ref )


            if ( !itemWidth || !containerWidth )
                return;


            context.hasReady = true
            context.hasComplete = false
            context.containerWidth = containerWidth
            context.containerHeight = containerHeight
            context.itemWidth = itemWidth
            context.gap = gap
            context.count = count


            // delete old masonry 
            if ( context.masonry ) {
                context.masonry.destroy()
            }

            // @ts-ignore
            context.masonry = new window.Masonry( ref, {
                columnWidth: parseInt( itemWidth ),
                gutter: parseInt( gap ),
                resize: false,
                initLayout: false,
                horizontalOrder: context.layout?.masonry === 'keepOrder',
                transitionDuration: 0
            } )

            context.masonry.on( 'layoutComplete', () => { 
                context.hasComplete = true
                context.containerHeight = null
            } )


            setTimeout( () => {
                context.masonry.layout()
            }, 150 )
        },
        /*updateLayout: () => {
            const context = getContext()

            if ( context.hasReady && !!context.masonry && !context.hasComplete ) {
                setTimeout( () => {
                    context.masonry.layout()
                }, 200 )
            }
        },*/
        onRouteChange: () => {
            /** @type {any} */
            const context = getContext()
            const { ref } = getElement()
            const { url } = getServerState( 'core/router' )

            /** @type {any} */
            const [ locUrl, setLocUrl ] = useState()
            

            useEffect( () => {
                if ( !!context.masonry && context.hasReady ) {
                    if ( url === locUrl ) {
                        //console.log( context )
                        context.masonry.reloadItems()
                        context.masonry.layout()
                        //context.hasComplete = false
                    } else {
                        setLocUrl( url )
                        //context.hasComplete = false
                    }
                }
            }, [
                url,
                ref?.innerHTML
            ] )
        },
        getGridLayout: ( /** @type {any} */ ref ) => {
            const { gridTemplateColumns, columnGap, width, height } = window.getComputedStyle( ref )
            const gridItems = gridTemplateColumns.split( ' ' )

            return {
                containerWidth: width,
                containerHeight: height,
                itemWidth: gridItems.at( 0 ),
                count: gridItems.length,
                gap: columnGap
            }
        },
    }
} )